import { useTheme } from '@lokalise/styled';

import CheckboxCheckedFilled from '../icons/CheckboxCheckedFilled';
import CheckboxEmpty from '../icons/CheckboxEmpty';
import { iconSize } from '../styles';
import type { CheckboxIconProps } from '../styles';

const DisabledCheckbox = ({ checked }: CheckboxIconProps) => {
    const theme = useTheme();

    return checked ? (
        <CheckboxCheckedFilled color={theme.color.text.disabled} size={iconSize} />
    ) : (
        <CheckboxEmpty
            secondaryColor={theme.color.background.surface.middle}
            color={theme.color.text.disabled}
            size={iconSize}
        />
    );
};

export default DisabledCheckbox;
